import { useFormikContext } from 'formik';

import { Button } from '@/components/ui/button';

import type { BatchCallFormValues } from '@/schemas/batch-call.schema';

type Props = {
  onCancel: () => void;
  isSubmitting?: boolean;
};

export const FormActions = ({ onCancel, isSubmitting }: Props) => {
  const { isValid } = useFormikContext<BatchCallFormValues>();

  return (
    <div className="flex gap-2 pt-4 border-t border-zinc-200">
      <Button type="button" variant="outline" onClick={onCancel} className="flex-1">
        Cancel
      </Button>
      <Button type="submit" disabled={!isValid || isSubmitting} className="flex-1">
        {isSubmitting ? 'Creating…' : 'Create Batch Call'}
      </Button>
    </div>
  );
};
